var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-background",attrs:{"id":"app"}},[_c('router-view'),_c('loading-overlay'),_c('modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }